export default __webpack_public_path__ + "static/media/GuyAnimation13.30f5d427.svg";